import React from "react";
import { Redirect } from "react-router-dom";

import InferenceMachinesView from "./views/InferenceMachinesView";
import InstallationListView from "./views/InstallationListView";
import InstallationDetailView from "./views/InstallationDetailView";
import InstallationSettingsView from "./views/InstallationSettingsView";
import RemoteControlView from "./views/RemoteControlView";
import NetworkView from "./views/NetworkView";
import StoresView from "./views/StoresView";
import StoreDetailView from "./views/StoreDetailView";
import StoreScreenshotToolsView from "./views/StoreScreenshotToolsView";
import StoreCapabilitiesView from "./views/StoreCapabilitiesView";
import InferenceMachineDetailView from "./views/InferenceMachineDetailView";
import GlobalStreamConfigView from "./views/GlobalStreamConfigView";
import SensitivityConfigView from "./views/SensitivityConfigView";
import PreSettingsView from "./views/PreSettingsView";
import LoginView from "./views/LoginView";
import LogoutView from "./views/LogoutView";
import {
  adminEditorRole,
  adminViewerRole,
  csmMaintenanceRole,
  csmRole,
  dashcamRoles,
  technicianRole,
  techopsRole,
  viewerRole,
} from "./components/shared/constants";
import StoreHistory from "./views/stores-history/stores/StoreHistory";
import UserHistory from "./views/stores-history/users/UserHistory";
import HistoryView from "./views/stores-history/HistoryView";
import SimulationStatusView from "./views/SimulationStatusView";

const routes = [
  {
    path: "stores",
    name: "Stores",
    icon: "",
    component: StoresView,
    layout: "/",
    roles: [viewerRole],
    subRoutes: [
      {
        path: ":id",
        name: "Store Details",
        icon: "",
        component: StoreDetailView,
        layout: "stores/",
        roles: [viewerRole],
      },
    ],
  },
  {
    path: "inferencemachines",
    name: "Inference Machines",
    icon: "",
    component: InferenceMachinesView,
    layout: "/",
    roles: [viewerRole],
    subRoutes: [
      {
        path: ":id",
        name: "Inference Machine",
        icon: "",
        component: InferenceMachineDetailView,
        layout: "inferencemachines/",
        roles: [viewerRole],
      },
    ],
  },
  {
    path: "remotecontrol",
    name: "Remote Control",
    icon: "",
    component: RemoteControlView,
    layout: "/",
  },
  {
    path: "streamconfig",
    name: "Stream Config",
    icon: "",
    component: GlobalStreamConfigView,
    layout: "/",
    roles: [adminViewerRole, adminEditorRole],
  },
  {
    path: "sensitivity-config",
    name: "Sensitivity Config",
    icon: "",
    component: SensitivityConfigView,
    layout: "/",
    roles: [adminViewerRole, adminEditorRole],
  },
  {
    path: "pre-settings",
    name: "Pre-Settings",
    icon: "",
    component: PreSettingsView,
    layout: "/",
    roles: [adminViewerRole, adminEditorRole],
  },
  {
    path: "onboarding-presettings",
    name: "Pre-Settings",
    icon: "",
    component: () => React.createElement(Redirect, { to: "/pre-settings" }),
    layout: "/",
    roles: [adminViewerRole, adminEditorRole],
    redirect: true,
  },
  {
    path: "history/",
    name: "History",
    icon: "",
    component: HistoryView,
    layout: "/",
    roles: [adminViewerRole, adminEditorRole, techopsRole, technicianRole, csmRole, csmMaintenanceRole],
    subRoutes: [
      {
        path: ":storeLocation",
        name: "Store History",
        icon: "",
        component: StoreHistory,
        layout: "history/stores/",
        roles: [adminViewerRole, adminEditorRole, techopsRole, technicianRole, csmRole, csmMaintenanceRole],
      },
      {
        path: ":username",
        name: "User history",
        icon: "",
        component: UserHistory,
        layout: "history/edits/",
        roles: [adminViewerRole, adminEditorRole, techopsRole],
      },
    ],
  },
  {
    path: "installations",
    name: "Installations",
    icon: "",
    component: InstallationListView,
    layout: "/",
    roles: [viewerRole],
    subRoutes: [
      {
        path: ":identifier",
        name: "Installation",
        icon: "",
        component: InstallationDetailView,
        layout: "installations/",
        roles: [viewerRole],
      },
    ],
  },
  {
    path: "installation-settings",
    name: "Installation Settings",
    icon: "",
    component: InstallationSettingsView,
    layout: "/",
    roles: [adminViewerRole, adminEditorRole],
    redirect: true,
  },
  {
    path: "stores-in-simulation",
    name: "Simulations Status",
    icon: "",
    component: SimulationStatusView,
    layout: "/",
    roles: [viewerRole],
  },
  {
    path: "network",
    name: "Network",
    icon: "",
    component: NetworkView,
    layout: "/",
  },
  {
    path: "login",
    name: "Login",
    icon: null,
    component: LoginView,
    layout: "/connect/",
  },
  {
    path: "logout",
    name: "Logout",
    icon: null,
    component: LogoutView,
    layout: "/connect/",
  },
  {
    path: "screenshots",
    name: "Screenshots",
    icon: "",
    layout: "/",
    subRoutes: [
      {
        path: ":location",
        name: "Store Screenshot tools",
        icon: "",
        component: StoreScreenshotToolsView,
        layout: "screenshots/",
      },
    ],
  },
  {
    path: "capabilities",
    name: "Capabilities",
    icon: "",
    layout: "/",
    subRoutes: [
      {
        path: ":location",
        name: "Store Capabilities",
        icon: "",
        component: StoreCapabilitiesView,
        layout: "capabilities/",
        roles: dashcamRoles,
      },
    ],
  },
];

export default routes;
